module.exports = "../dist/img/white-33.b7ba.jpg";